module.exports = __webpack_public_path__ + "static/media/thunderstorm.c55d3736.svg";